import React from 'react';
import { useOfficeReviewsV2 } from '../../../../hooks/useOfficeReviewsV2';
import { RatingDetailsLegacy } from './RatingDetails.legacy';
import { RatingDetailsV2 } from './RatingDetailsV2';

/**
 * The Job Detail Rating tab, gated on GOTU-6266.
 *
 * `RatingDetailsV2`'s office card reads organization-service by shift id, and
 * that service has not shipped — so until it does, the tab falls back to the
 * pre-GOTU-7339 cards, which take both sides off `state.jobs.rating`.
 *
 * **This surface is the more urgent of the epic's two gates, and the reason is
 * not obvious.** `GetOfficeReviewByShift` maps a 404 to `null` on purpose: a
 * shift nobody reviewed, a malformed job id and a soft-deleted review all
 * legitimately mean "nothing to show". Point that at a service which isn't
 * deployed and every shift reads *"No review submitted"* — a confident, wrong
 * answer an admin may act on, rather than a visible error. The office Reviews
 * table at least fails loudly.
 *
 * **The branch sits above `RatingDetailsV2`, not inside it.**
 * `useGetOfficeReviewByShift` is a React Query hook and cannot be called
 * conditionally, so gating within the V2 body would fire the request and only
 * then decide not to render it. Choosing which component mounts is what keeps
 * the flag-off path off the network entirely.
 *
 * Retire this file with the flag: fold `RatingDetailsV2` back in here and
 * delete `RatingDetails.legacy`, `RatingCard.legacy` and their scss modules.
 */
const RatingDetails = () => {
  const isOfficeReviewsV2Enabled = useOfficeReviewsV2();

  return isOfficeReviewsV2Enabled ? <RatingDetailsV2 /> : <RatingDetailsLegacy />;
};

export { RatingDetails };
export default RatingDetails;
